// B1691: the load sequence of the query console's schema tree (SHOW COLLECTIONS).
//
// The tree reloads on mount, on a reconnect after an error, on Retry and on a
// database switch. These requests can overlap. Two rules apply:
//
// - A request during a load does not start a second fetch at once. It queues ONE
//   more load, which starts when the current load ends. Many requests during one
//   load still give one more fetch.
// - A load that a newer request supersedes does not reach the sink. Its result
//   can belong to the old database, so it must never replace the newer list.
//
// Before B1691 a request during a load was dropped, so a switch of database
// during a load kept the list of the old database.

export function createSchemaLoader({ fetch, onStart, onResult, onError }) {
  let generation = 0;   // increments on each request
  let running = null;   // the promise of the load loop, or null when idle

  async function run() {
    try {
      for (;;) {
        const mine = generation;
        let ok = false, value;
        try { value = await fetch(); ok = true; }
        catch (e) { value = e; }
        // A newer request arrived during the fetch: discard this answer and load again.
        if (mine !== generation) continue;
        if (ok) onResult(value); else onError(value);
        return;
      }
    } finally { running = null; }
  }

  // Request a load. The promise resolves when the newest requested load is in the sink.
  function reload() {
    generation++;
    onStart();
    if (!running) running = run();
    return running;
  }

  return { reload };
}
